import React from 'react';
import { IconProps } from '.';

const SvgWarningBold = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M13.5 20h-3v-3h3v3ZM13.5 14h-3V4h3v10Z' />
    </svg>
  );
};

export default SvgWarningBold;
